/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Szoa206aResponseAceptError {
    /**
     * 受付エラー発生システムコード：英数字<br>　コード変換マスターテーブル.画面項目ID「C402030」のユーザコードを設定
     */
    acperrSyscd?: string;
    /**
     * 受付エラー発生システムコード名称：全半角混在
     */
    acperrSyscdAname?: string;
    /**
     * 受付エラーメッセージレベル：英数字<br>　コード変換マスターテーブル.画面項目ID「C400030」のユーザコードを設定
     */
    aceptErrmsg?: string;
    /**
     * 受付エラーメッセージレベル名称：全半角混在
     */
    aceptErrmsgAname?: string;
    /**
     * 受付エラー理由：半角
     */
    aceptErrrsn?: string;
    /**
     * 受付エラー理由名称：全半角混在
     */
    aceptErrrsnAname?: string;
}

